module.exports = __webpack_public_path__ + "img/18.814d5772.png";